import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MainGuard implements CanActivate {
  constructor(private oAuth: AuthService, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    if (this.oAuth.isAuthenticated()) {
      this.oAuth.expiredToken().then(isExpired => {
        console.log(isExpired);
        
        if (isExpired) {
          this.oAuth.logout();
          return false;
        }
        else {
          return true;
        }
      });

      return true;
    }
    else {
      this.router.navigate(['/login']);
      return false
    }
  }
}
